// document.addEventListener('DOMContentLoaded', () => {
//   const collectionListSwiper = new Swiper('.collection-list-slider', {
//     slidesPerView: 1,
//     spaceBetween: 5,
//     freeMode: true,
//     centeredSlides: false,
//     initialSlide: 0,
//     loop: false,
//     navigation: {
//         nextEl: ".swiper-button-next",
//         prevEl: ".swiper-button-prev",
//         disabledClass: 'disabled_swiper_button'
//     },
//     breakpoints: {
//         640: {
//             slidesPerView: 2,
//             spaceBetween: 20,
//         },
//         768: {
//             slidesPerView: 3,
//             spaceBetween: 10,
//         },
//         1120: {
//             slidesPerView: 4,
//             spaceBetween: 10
//         }
//     }
//   });
// });

document.addEventListener('DOMContentLoaded', () => {
    var swiper = new Swiper(".Product__SlideshowNav--thumbnails", {
        slidesPerView: 5,
        spaceBetween: 5,
        freeMode: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });
});